"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const BaseController_1 = __importDefault(require("./BaseController"));
const moment_1 = __importDefault(require("moment"));
const AuthService_1 = __importDefault(require("../services/AuthService"));
class CheckinApi extends BaseController_1.default {
    constructor() {
        super();
        this.url_locations = `${this.apiHost}/${this.apiPathMedical}/checkin/locations`;
        this.url_location_times = `${this.apiHost}/${this.apiPathMedical}/checkin/operating_hours`;
        this.url_location_times_batch = `${this.apiHost}/${this.apiPathMedical}/checkin/operating_hours_batch`;
    }
    fetchLocations() {
        return __awaiter(this, void 0, void 0, function* () {
            let response = yield fetch(this.url_locations, yield this.requestHeaderGet());
            if (response.status === 200) {
                let data = yield response.json();
                return { locations: data, error: false };
            }
            else {
                return {
                    error: true
                };
            }
        });
    }
    fetchLocationTimes(locationId) {
        return __awaiter(this, void 0, void 0, function* () {
            let response = yield fetch(`${this.url_location_times}?location_id=${locationId}`, yield this.requestHeaderGet());
            if (response.status === 200) {
                let data = yield response.json();
                let dataNormalised = data.map(time => {
                    time.open_time = (0, moment_1.default)(time.open_time, "hh:mm A");
                    time.close_time = (0, moment_1.default)(time.close_time, "hh:mm A");
                    return time;
                });
                return { times: dataNormalised, error: false };
            }
            else {
                return {
                    error: true
                };
            }
        });
    }
    putLocation(location) {
        return __awaiter(this, void 0, void 0, function* () {
            let postData = {
                id: location.id,
                name: location.name,
                medical_queue_indicator: location.medical_queue_indicator
            };
            let token = yield AuthService_1.default.getToken();
            const putOptions = {
                method: "PUT",
                headers: new Headers({
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                }),
                body: JSON.stringify(postData)
            };
            let response = yield fetch(this.url_locations, putOptions);
            if (response.status === 200) {
                return { id: location.id, error: false };
            }
            else {
                return { id: location.id, error: true };
            }
        });
    }
    putLocationOperatingHours(lt) {
        return __awaiter(this, void 0, void 0, function* () {
            let payload = {
                location_id: lt.location_id,
                day_of_week: lt.day_of_week,
                open_time: (0, moment_1.default)(lt.open_time).format("HH:mm:ss"),
                close_time: (0, moment_1.default)(lt.close_time).format("HH:mm:ss"),
                is_open: lt.is_open
            };
            let token = yield AuthService_1.default.getToken();
            const putOptions = {
                method: "PUT",
                headers: new Headers({
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                }),
                body: JSON.stringify(payload)
            };
            let response = yield fetch(this.url_location_times, putOptions);
            if (response.status === 200) {
                return { error: false };
            }
            else {
                return {
                    error: true
                };
            }
        });
    }
    putLocationOperatingHoursBatch(lt_list) {
        return __awaiter(this, void 0, void 0, function* () {
            let payload = lt_list.map((lt) => {
                let item = {
                    location_id: lt.location_id,
                    day_of_week: lt.day_of_week,
                    open_time: (0, moment_1.default)(lt.open_time).format("HH:mm:ss"),
                    close_time: (0, moment_1.default)(lt.close_time).format("HH:mm:ss"),
                    is_open: lt.is_open
                };
                return item;
            });
            let token = yield AuthService_1.default.getToken();
            const putOptions = {
                method: "PUT",
                headers: new Headers({
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                }),
                body: JSON.stringify(payload)
            };
            let response = yield fetch(this.url_location_times_batch, putOptions);
            if (response.status === 200) {
                return { error: false };
            }
            else {
                return {
                    error: true
                };
            }
        });
    }
}
const checkinApi = new CheckinApi();
exports.default = checkinApi;
